import React, { CSSProperties, ReactElement } from "react";
import Checkbox from "./Checkbox";

interface Props {
  label?: string;
  checked?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  style?: CSSProperties;
}

/**
 * @deprecated in favor of <Checkbox />
 */
export function AppCheckbox(props: Props): ReactElement {
  return <Checkbox {...props} />;
}
